<template>
  <scoped>
    <h1>
      Deliverable
    </h1>
    <table v-if="deliverable">
      <tbody>
        <tr>
          <th>
            Type
          </th>
          <td>
            {{ deliverable.type }}
          </td>
        </tr>
        <tr>
          <th>
            Trademark
          </th>
          <td>
            <template v-if="deliverable.trademark">
              {{ deliverable.trademark.name }}
            </template>
          </td>
        </tr>
        <tr>
          <th>
            Name
          </th>
          <td>
            {{ deliverable.name }}
          </td>
        </tr>
        <tr>
          <th>
            EAN
          </th>
          <td>
            {{ deliverable.ean }}
          </td>
        </tr>
        <tr>
          <th>
            Description
          </th>
          <td>
            {{ deliverable.description }}
          </td>
        </tr>
        <tr>
          <th>
            Unit
          </th>
          <td>
            {{ deliverable.unit }}
          </td>
        </tr>
        <tr>
          <th>
            Currency
          </th>
          <td>
            {{ deliverable.currency }}
          </td>
        </tr>
        <tr>
          <th>
            Net Unit Price
          </th>
          <td>
            <template v-if="deliverable.unitPrice && deliverable.unitPrice.net">
              {{ Number(deliverable.unitPrice.net).toFixed(2) }}
            </template>
          </td>
        </tr>
        <tr>
          <th>
            Gross Unit Price
          </th>
          <td>
            <template v-if="deliverable.unitPrice && deliverable.unitPrice.gross">
              {{ Number(deliverable.unitPrice.gross).toFixed(2) }}
            </template>
          </td>
        </tr>
        <tr>
          <th>
            VAT Rate
          </th>
          <td>
            <template v-if="deliverable.vatRate">
              {{ Number(deliverable.vatRate).toFixed(2) }}%
            </template>
          </td>
        </tr>
        <tr>
          <th>
            Memorandum
          </th>
          <td>
            {{ deliverable.memorandum }}
          </td>
        </tr>
      </tbody>
    </table>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import {Deliverable as DeliverableClient} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {onBeforeMount, ref} from "vue"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  const props = defineProps({
    deliverableID: {
      default: null,
      required: true,
      type: String
    }
  })

  const error = ref<Error>(null)
  const deliverableClient = new DeliverableClient()
  const deliverable = ref<Deliverable>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      deliverable.value = await deliverableClient.summary(props.deliverableID)
    } catch(e) {
      error.value = e
    }
  }
</script>
